import { CommonModule, NgClass } from '@angular/common';
import { Component, ElementRef, inject, input } from '@angular/core';
import { AuiIconComponent } from '@ral/ui:aui/icons';
import { AuiIcon } from '@ral/utils:core/ui';

@Component({
    selector: 'aui-input-group',
    standalone: true,
    template: `<div
        class="flex flex-nowrap divide-surface-background-darken overflow-hidden rounded outline-surface-background-darken"
        [ngClass]="{ 'divide-x divide-solid outline outline-1': !readonly() }"
    >
        <ng-content> </ng-content>
    </div>`,
    imports: [CommonModule, NgClass],
    styles: [``],
})
export class AuiInputGroupComponent {
    el = inject(ElementRef);
    readonly = input<boolean>(false);
}

@Component({
    standalone: true,
    selector: 'aui-input-group-addon',
    template: ` <div
        class="text-surface-background-dark-text flex h-full w-full items-center justify-center gap-2 bg-surface-background-darkie px-2"
    >
        @if (icon(); as icon) {
            <aui-icon [icon]="icon" />
        }
        @if (label(); as label) {
            <span class="text-nowrap">{{ label }}</span>
        }
        @if (rightIcon(); as rightIcon) {
            <aui-icon [icon]="rightIcon" />
        }
    </div>`,
    imports: [CommonModule, AuiIconComponent],
})
export class AuiInputGroupAddonComponent {
    icon = input<AuiIcon>();
    label = input<string>();
    rightIcon = input<AuiIcon>();
}
